
import { Types } from "../actions/actionTypes";

let initialState = {
    hospitalData: {}
}

export const hospitalDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.HOSPITAL_DATA:
            {
                let hospitalId = action.payload.id;
                let hospitalName = action.payload.hospitalName;

                let hData = state.hospitalData;

                if (hospitalId) hData.hospitalId = hospitalId;
                if (hospitalName) hData.hospitalName = hospitalName;

                return {
                    ...state,
                    hospitalData: { ...hData }
                };
            }
        default:
            return state;
    }
}